// extracted by mini-css-extract-plugin
module.exports = {"socialButton":"style_socialButton__jV33h"};